import React from 'react'
import ReactDOM from 'react-dom'

import AppLayout from "../../../core/gd-app/component/app-layout"
import AppMain from "../../../core/gd-app/component/app-main/app-main"
import {SharedViewLogoType} from "../../../core/modules/shared-views/types"

export default class SharedViewAppProto {

    protected domContainerId    : string        = "ui-content-center" // dom id we mount this app in, id of layout container for app
    protected _domContainer?    : HTMLElement   // dom container

    public publicKey!: string
    public apiData: any
    public sharedView: any
    public customView: any

    public logo!: SharedViewLogoType

    constructor() {

    }

    init(appParams: any) {

        this.publicKey      = appParams.publicKey;
        this.apiData        = _.get(appParams, 'apiResponse.data', null);
        this.sharedView     = _.get(appParams, 'apiResponse.sharedView', null);
        this.customView     = _.get(appParams, 'apiResponse.customView', null);

        // Experimental
        this.logo           = gd?.modules?.sharedViews.logo // we need ? as in shared view gd.modules not initialized by def

        return this;
    }

    __destroy() {
        gd.bus.unsubscribe(this);
    }

    get domContainer():HTMLElement {
        if (!this._domContainer) {
            // @ts-ignore
            this._domContainer = document.getElementById(this.domContainerId)
        }

        if (!this._domContainer) {
            throw Error("#jdhsd8972 NO Dom container found")
        }

        return this._domContainer
    }

    showBusy(callback: func) {
        gd.layout.loading.showAppBusy(callback);
    }

    hideBusy() {
        gd.layout.loading.hide();
    }

    renderNotFound() {
        const errorNumber = "404";
        const message = "The requested page is not found";

        ReactDOM.render(
            <AppLayout className="error-page">
                <AppMain className="main" type="full">
                    <div className="block">
                        <div className="error-number">{errorNumber}</div>
                        <div className="message">{message}</div>
                    </div>
                </AppMain>
            </AppLayout>,
            this.domContainer
        )
    }

    render(pageContent?:any, callback?:callback) {
        ReactDOM.render(
            pageContent,
            this.domContainer,
            ()=>{
                gd.layout.loading.hide()
                if (callback) callback()
            }
        )
    }
}